<div class="change__balance-container">
  <div [class]="!!inputData ? 'change__balance-header p-0' : 'change__balance-header'">
    @if(!inputData){
    <h5>Update {{ data?.title ?? inputData?.title }}</h5>
    }@else{
    <p class="text-xl font-semibold text-[#53565B] leading-8">
      Add <span class="text-[#25508E]">{{ data?.title ?? inputData?.title }}</span> for <span class="text-[#25508E]">{{ inputData.form_name }}</span>
    </p>
    } @if(!inputData){
    <div class="web__close-icon">
      <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
    }
  </div>
  <div [class]="!!inputData ? 'change__balance-form p-0 setup-max-w' : 'change__balance-form'">
    <form [formGroup]="attributeForm" #formTemplate>
      @for (control of formKeys;track control.key;let i = $index) {
      <div [class]="i !== 0 ? 'mt-3 relative' : 'relative'">
        @if(control?.type == 'Dollar Input'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="false"
          [styledIcon]="true"
          [isNegativeAllowed]="false"
          [hideIcons]="false"
          (click)="(null)"
          [id]="control.key"
          [focusId]="focusId"
        >
        </input-number-effect>
        } @if(control?.type == 'Percentage' || control?.type == 'Percentage Input'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="true"
          [styledIcon]="true"
          [isNegativeAllowed]="false"
          [hideIcons]="false"
          (click)="(null)"
          [id]="control.key"
          [focusId]="focusId"
        >
        </input-number-effect>
        } @if(control?.type.includes('Numeric Input')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="false"
          [styledIcon]="false"
          [isNegativeAllowed]="false"
          [hideIcons]="true"
          (click)="(null)"
          [id]="control.key"
          [focusId]="focusId"
        >
        </input-number-effect>
        }
        <!--  -->
        @if(control?.type == 'Switch'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <div class="w-full p-3 rounded-md border border-[#E0DEDF] flex justify-between items-center text-sm font-semibold">
          {{ control?.title }}
          <mat-slide-toggle [formControlName]="control?.key"> </mat-slide-toggle>
        </div>
        } @if (hasCategoryDropDown(control)) { @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <income-expense-dropdown [control]="control" [premiumForm]="attributeForm" #incomeExpenseDropdown></income-expense-dropdown>
        } @if(control?.type == 'Assets & Liabilities'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <mat-form-field appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only add-automtic-form-desing full-width">
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input matInput type="text" [placeholder]="control.value" [value]="control.value" [formControlName]="control?.key" />
        </mat-form-field>
        } @if(control?.key == 'effective_date' || control.type == 'Date Selection' || control.type =="Date" || control?.key == 'as_of'){

        <mat-form-field appearance="fill" class="form-design-ui">
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input
            matInput
            [matDatepicker]="dp3"
            (dblclick)="dp3.open()"
            [formControlName]="control?.key ?? 'effective_date'"
            (change)="handleDateChange($event, control?.key, control)"
          />
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
        } @if(control?.type.includes('Dropdown')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <div class="dropdown">
          <mat-form-field
            appearance="fill"
            style="width: 100% !important"
            class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
          >
            <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
            <mat-select [formControlName]="control?.key" disableOptionCentering required (selectionChange)="setValue($event.value, control)">
              @for (item of handleDropDownTypes(control); track $index) {
              <mat-option [value]="item">
                {{ item }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        } @if(!control?.type.includes('Dropdown') && !!getType(control.type)){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <mat-form-field
          appearance="fill"
          style="width: 100% !important"
          class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
        >
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <mat-select [formControlName]="control?.key" disableOptionCentering required (selectionChange)="setValue($event.value, control)">
            @for (item of control.type; track $index) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </div>

      } @if( !inputData ){ @if(setupItem?.status !== 'complete' && !!data?.balanceData?.additional_data ||
      !data?.existingAttributesList?.value?.History || !!data?.existingAttributesList?.value?.History && setupItem?.status !== 'complete' ){
      @if(!hide_mark_complete){
      <div class="app__attribute--dialog flex gap-1 items-center justify-start mt-2 mb-[-8px]">
        @if (!!setupItem) {
        <mat-slide-toggle (change)="toggleActive($event)" [checked]="isSetupItemEnable" class="text-sm text-k-grey">
          Mark this attribute as complete</mat-slide-toggle
        >
        }
      </div>

      } } } @else if( setupItem?.status !== 'complete' && !!inputData ) {
      <div class="app__attribute--dialog flex gap-1 items-center justify-start mt-2 mb-[-8px]">
        @if(!hide_mark_complete){
        <mat-slide-toggle (change)="toggleActive($event)" [checked]="isSetupItemEnable" class="text-sm text-k-grey">
          Mark this attribute as complete</mat-slide-toggle
        >
        }
      </div>
      } @if(!fromSetup){
      <div class="mb-5">
        <button
          [class]="
            attributeForm.valid || (isSetupItemEnable && setupItem?.status !== 'complete') || setupItem?.status == 'complete'
              ? 'app__btn--primary mb-0 mt-5 rounded-lg'
              : 'app__btn--disabled mb-0 mt-5 rounded-lg'
          "
          (click)="
            attributeForm.valid || (isSetupItemEnable && setupItem?.status !== 'complete') || (!isSetupItemEnable && setupItem?.status == 'complete')
              ? submitForm()
              : null
          "
        >
          Save
        </button>
      </div>
      }
    </form>
  </div>
</div>
